"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];

const DreamnDateTabs = ({ selectedDate, onDateChange }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: todayString,
      label: "Hôm nay",
      dateLabel: today.format("DD-MM"),
      type: "today",
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      dateLabel: tomorrow.format("DD-MM"),
      type: "tomorrow",
    });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        dateLabel: d.format("DD-MM"),
        type: "future",
      });
    }

    return options;
  }, [todayString]);

  return (
    <div className="kbv-dreamn-date-tabs flex w-full min-w-0 flex-row flex-nowrap gap-3 overflow-x-auto select-none no-scrollbar py-2 px-0.5 sm:gap-4 md:gap-2 md:overflow-x-visible md:px-0">
      {dateOptions.map((opt) => {
        const isSelected = selectedDate === opt.value;
        return (
          <div
            key={opt.value}
            role="button"
            tabIndex={0}
            onClick={() => onDateChange(opt.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onDateChange(opt.value);
              }
            }}
            className={`kbv-date-tab-pill flex min-h-[2.75rem] min-w-20 shrink-0 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-3xl border border-transparent px-2 py-2 transition-all duration-200 sm:px-2.5 sm:py-2 md:min-w-0 md:flex-1 md:basis-0 md:max-w-none ${
              isSelected
                ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)] kbv-date-shadow-active-navy-slate"
                : "bg-[var(--theme-accent)] text-[var(--theme-text-muted)] hover:bg-gray-200 kbv-date-shadow-inactive-navy-slate"
            }`}
          >
            <span className="w-full text-center text-sm font-bold leading-tight">
              {opt.label}
            </span>
            <span className="w-full text-center text-xs font-medium leading-tight opacity-80">
              {opt.dateLabel}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default DreamnDateTabs;
